import gql from "graphql-tag";

export default gql`
  fragment CoverFields on Cover {
    id
    blurhash
    mimeType
    width
    height
    dominantColor
    colorPalette
    url
  }
`;
